import { Currency } from './globalTypes'

export const apiDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss.SSS'
export const AVAILABLE_CURRENCY: Currency[] = [Currency.CAD, Currency.EUR, Currency.RUB, Currency.USD]
export const DATE_FORMAT = 'dd.MM.yy'
export enum STORAGE_KEYS {
  ProcoteQuestionnaire = 'procote_questionnaire',
}
export const POUNDS_TO_KILOGRAMS = 2204.62
export const EMPTY_ARRAY = []
